module.exports = __webpack_public_path__ + "static/media/leadpages4.ded34f71.png";